import useInputChange from "hooks/useInputChange";
import { FormEvent, useEffect } from "react";
import { SubscriptionPlanFeature } from "types/subscription.interface";

interface Props {
  onSubmit: (data: SubscriptionPlanFeature) => void;
  data?: SubscriptionPlanFeature;
  onCancel: () => void;
}
export default function FeatureForm({ onSubmit, onCancel, data }: Props) {
  const { state, onChange, setState } = useInputChange<SubscriptionPlanFeature>(
    {
      name: data?.name || "",
      description: data?.description || "",
      available: data?.available || true,
    }
  );

  //   useEffect(() => {
  //     if (data) setState(data);
  //   }, [data]);

  const handleSubmit = (e: FormEvent) => {
    // e.preventDefault();

    onSubmit(state);
  };

  return (
    <form key={JSON.stringify(data)}>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">Name</label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="ProfileView"
          name="name"
          onChange={onChange}
          value={state.name}
        />
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Description
        </label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Enter Description"
          name="description"
          onChange={onChange}
          value={state.description}
        />
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="reset"
          data-modal-close="addDocuments"
          className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
        >
          Submit
        </button>
      </div>
    </form>
  );
}
